export default __webpack_public_path__ + "static/cdcsvIXZ-9d1653861bfa365a32439be00093de5a.svg";